type RouteState = Record<string, string | number | undefined>;
type UiIndexState = Partial<{
    query: string;
    page: number;
    hitsPerPage: number;
    sortBy: string;
    refinementList: Record<string, string[]>;
    range: Record<string, string>;
    configure: any;
}>;
type UiState = Record<string, UiIndexState>;
const isRelevantForUrlMapping = () => {
    return true;
};

export function seoFriendlyStateMapping(
    sorting: Array<{ label: string; code?: string; value: string }>,
    algoliaIndexName: string,
    refinementListConfig: Array<{ name: string; display_type: number }>
) {
    return {
        stateToRoute(uiState: UiState): RouteState {
            const s = uiState[algoliaIndexName] || {};
            const route: RouteState = {};

            if (s.query) route.input_search = s.query;

            if (typeof s.page === 'number' && s.page > 1) route.page = s.page;

            if (s.sortBy) {
                const found = sorting.find(x => x.value === s.sortBy);
                if (found?.code) route.sort_by = found.code;
            }

            // Remove hits_per_page from URL - it's an internal setting that shouldn't appear in user-facing URLs
            // const hpp = s.hitsPerPage ?? s.configure?.hitsPerPage;
            // if (typeof hpp === 'number' && hpp !== 24) route.hits_per_page = hpp;

            const filters: Record<string, string> = {};
            const refinementList = s.refinementList || {};
            const range = s.range || {};


            refinementListConfig.forEach(({ name, display_type }) => {
                if (!isRelevantForUrlMapping()) {
                    return;
                }
                const key = name.split(".")[1]?.toLowerCase();
                if (!key) {
                    return;
                }

                if (refinementList[name]) {
                    filters[key] = refinementList[name].join("|");
                }
                if (display_type === 3 && range[name]) {
                    const [from, to] = String(range[name]).split(":");
                    filters[`${key}_from`] = from;
                    filters[`${key}_to`] = to;
                }
            });

            return { ...route, ...filters };
        },

        routeToState(route: RouteState): UiState {
            const ui: UiIndexState = {};
            const refinementList: Record<string, string[]> = {};
            const range: Record<string, string> = {};

            if (route.input_search) ui.query = String(route.input_search);

            if (route.page != null) ui.page = Number(route.page);

            if (route.hits_per_page != null) {
                ui.hitsPerPage = Number(route.hits_per_page);
            } else if (route['configure[hitsPerPage]'] != null) {
                ui.hitsPerPage = Number(route['configure[hitsPerPage]']);
            }

            if (route.sort_by) {
                const found = sorting.find(x => x.code === route.sort_by);
                if (found) ui.sortBy = found.value;
            }

            refinementListConfig.forEach(({ name, display_type }) => {
                if (!isRelevantForUrlMapping()) return;
                const key = name.split(".")[1]?.toLowerCase();
                if (!key) return;

                const fromKey = `${key}_from`;
                const toKey = `${key}_to`;

                if (route[key]) {
                    refinementList[name] = String(route[key]).split("|");
                }
                if (display_type === 3 && route[fromKey] && route[toKey]) {
                    range[name] = `${route[fromKey]}:${route[toKey]}`;
                }
            });

            if (Object.keys(refinementList).length) ui.refinementList = refinementList;
            if (Object.keys(range).length) ui.range = range;

            return { [algoliaIndexName]: ui };
        },
    } as const;
}